// helpers.js
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';

import config from '../config';

export const constructAuthdetails = (email, password) => {
  return new AmazonCognitoIdentity.AuthenticationDetails({
    Username: email,
    Password: password
  });
};

export const constructUser = email => {
  let userpool = new AmazonCognitoIdentity.CognitoUserPool({
    UserPoolId: config.UserPoolID,
    ClientId: config.ClientId
  });
  return new AmazonCognitoIdentity.CognitoUser({
    Username: email,
    Pool: userpool
  });
};

export const makeAttrs = attrs => {
  let attributeList = [];
  for (let key in attrs) {
    let attribute = {
      Name: key,
      Value: attrs[key]
    };
    attribute = new AmazonCognitoIdentity.CognitoUserAttribute(attribute);
    attributeList.push(attribute);
  }
  return attributeList;
};



// WEBPACK FOOTER //
// ./src/utils/user/helpers.js